import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { AccountLayout } from "../components/AccountLayout";
import Cover from "../components/BookCover";
import { fetchMyOrders } from "../api";
import { getStoredAuthToken } from "../authStorage";

export default function MyOrdersPage({ user, onLogout }) {
    const navigate = useNavigate();
    const [orders, setOrders] = useState([]);
    const [loading, setLoading] = useState(true);
    const fmtINR = n => "₹" + n.toLocaleString("en-IN");

    useEffect(() => {
        const fetchOrders = async () => {
            try {
                const token = getStoredAuthToken();
                if (!token) {
                    setLoading(false);
                    return;
                }
                const data = await fetchMyOrders(token);
                setOrders(data);
            } catch (error) {
                console.error("Error fetching orders:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchOrders();
    }, [navigate]);

    return (
        <AccountLayout user={user} onLogout={onLogout}>
            <div className="orders-page-wrap" style={{ animation: "fadeUp 0.4s both" }}>
                <style>{`
                    @media (max-width: 600px) {
                        .order-header {
                            flex-direction: column !important;
                            align-items: flex-start !important;
                            gap: 12px !important;
                        }
                        .order-status-price {
                            width: 100% !important;
                            justify-content: space-between !important;
                        }
                        .order-card { padding: 16px !important; }
                    }
                `}</style>
                <h2 style={{ fontFamily: "'Playfair Display',serif", fontSize: 24, fontWeight: 800, color: "var(--ink)", marginBottom: 8 }}>My Orders</h2>
                <p style={{ fontSize: 13, color: "var(--text3)", marginBottom: 28 }}>Track and manage your orders.</p>

                <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
                    {loading ? (
                        <div style={{ padding: 40, textAlign: "center", color: "var(--text3)" }}>Loading orders...</div>
                    ) : orders.length === 0 ? (
                        <div style={{ padding: 40, textAlign: "center", color: "var(--text3)", background: "var(--paper)", borderRadius: 18, border: "1.5px dashed var(--border)" }}>
                            You have no orders yet.
                        </div>
                    ) : orders.map(order => (
                        <div key={order._id} className="order-card" onClick={() => { navigate(`/order/${order._id}`); window.scrollTo(0, 0); }} style={{
                            background: "var(--paper)", borderRadius: 18, border: "1.5px solid var(--border)", padding: 24,
                            cursor: "pointer", transition: "all 0.2s"
                        }}
                            onMouseEnter={e => { e.currentTarget.style.borderColor = "var(--forest)"; e.currentTarget.style.boxShadow = "var(--shadow)"; }}
                            onMouseLeave={e => { e.currentTarget.style.borderColor = "var(--border)"; e.currentTarget.style.boxShadow = "none"; }}
                        >
                            {/* Header */}
                            <div className="order-header" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
                                <div>
                                    <div style={{ fontWeight: 800, fontSize: 14, color: "var(--ink)", fontFamily: "'Nunito Sans',sans-serif" }}>Order #{String(order._id || order.id || "").slice(-8)}</div>
                                    <div style={{ fontSize: 12, color: "var(--text3)", marginTop: 2 }}>Placed on {new Date(order.createdAt).toLocaleDateString("en-IN", { day: 'numeric', month: 'short', year: 'numeric' })}</div>
                                </div>
                                <div className="order-status-price" style={{ display: "flex", alignItems: "center", gap: 10 }}>
                                    <span style={{ display: "inline-flex", alignItems: "center", padding: "4px 12px", borderRadius: 50, fontSize: 11, fontWeight: 800, letterSpacing: "0.04em", background: order.isPaid ? "#10B98118" : "#F59E0B18", color: order.isPaid ? "#10B981" : "#F59E0B" }}>{order.isPaid ? "Paid" : "Pending"}</span>
                                    <span style={{ fontFamily: "'Playfair Display',serif", fontWeight: 800, fontSize: 16, color: "var(--forest)" }}>{fmtINR(Number(order.totalPrice) || 0)}</span>
                                </div>
                            </div>
                            {/* Items preview */}
                            <div style={{ display: "flex", gap: 10 }}>
                                {order.orderItems.map((item, idx) => (
                                    <Cover key={idx} book={item} w={42} h={58} shadow={false} />
                                ))}
                                <div style={{ display: "flex", alignItems: "center", fontSize: 12, color: "var(--text3)", marginLeft: 4 }}>
                                    {order.orderItems.length} item{order.orderItems.length > 1 ? "s" : ""} →
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </AccountLayout>
    );
}
